import ModelUtil from '@leverege/model-util';
import { GeoPointModel } from '@leverege/molten/data-viewers';
const TYPE = 'recovr.mapRenderer.ZoneVehicleModel';
function create(layerName, name, objectType, extend) {
  return {
    ...GeoPointModel.create(layerName, name, objectType, extend),
    type: TYPE,
    symbolizer: null,
    spread: {
      increaseWithZoom: false,
      radius: 50
    },
    showAccuracyOn: 'selected',
    lineStyle: {
      color: {
        type: 'colorizer.Value',
        color: 'rgb(22, 97, 215)'
      },
      // Colorizer,
      width: 2,
      style: 'default',
      dashArray: null,
      // [ 8, 3 ]
      pattern: null,
      opacity: 1,
      cap: 'round',
      join: 'round'
    },
    fillStyle: {
      color: {
        type: 'colorizer.Value',
        color: 'rgb(22, 97, 215)'
      },
      // Colorizer,
      pattern: null,
      // for image bgs
      opacity: 0.5
    }
  };
}
export default {
  ...GeoPointModel,
  create,
  TYPE,
  ...ModelUtil.createAllValue('spread/increaseWithZoom', 'IncreaseSpreadWithZoom'),
  ...ModelUtil.createAllValue('spread/radius', 'SpreadRadius'),
  ...ModelUtil.createAllValue('showAccuracyOn', 'ShowAccuracyOn'),
  ...ModelUtil.createAllValue('lineStyle/color', 'LineColor'),
  ...ModelUtil.createAllValue('lineStyle/width', 'LineWidth'),
  ...ModelUtil.createAllValue('lineStyle/style', 'LineStyle'),
  ...ModelUtil.createAllValue('lineStyle/pattern', 'LinePattern', {
    validate: ModelUtil.isStringTrimAndNull
  }),
  ...ModelUtil.createAllValue('lineStyle/dashArray', 'LineDashArray', {
    validate: ModelUtil.isNumberArray
  }),
  ...ModelUtil.createAllValue('lineStyle/opacity', 'LineOpacity'),
  ...ModelUtil.createAllValue('lineStyle/cap', 'LineCap'),
  ...ModelUtil.createAllValue('lineStyle/join', 'LineJoin'),
  ...ModelUtil.createAllValue('fillStyle/color', 'FillColor'),
  ...ModelUtil.createAllValue('fillStyle/pattern', 'FillPattern', {
    validate: ModelUtil.isStringTrimAndNull
  }),
  ...ModelUtil.createAllValue('fillStyle/opacity', 'FillOpacity')
};